function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 25,
  fill: "white"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.228 33.152l-.211.086c-1.258.42-3.142 1.047-4.78 1.844a.54.54 0 00-.167.166c-.045.083-.09.17-.125.253-.175.419-.46 1.05-.547 1.34l-.08.215v.08l.036.045h.044l.202-.084c.47-.214 1.053-.547 1.644-.838h.039a151.806 151.806 0 003.229-1.552s.124-.083.21-.208l.586-1.177v-.083c0-.087-.044-.125-.08-.087zM18.53 31.31c.086-.17.458-.883.547-1.05v-.041a74.364 74.364 0 019.218-13.504l.09-.127c.045-.043.045-.084 0-.125-.045-.042-.09-.085-.125-.042h-.167c-2.354.337-4.742.756-7.087 1.342-.256.084-.38.211-.425.25-1.76 2.098-3.398 4.32-4.953 6.587.05.125.05.378.05.378s.372 2.934.923 5.116C15.257 34.077 14 39.36 14 39.36v.086c0 .041.045.041.08.041h.797c.042 0 .086-.04.131-.083l.036-.169a74.543 74.543 0 012.726-6.46c.255-.464.76-1.466.76-1.466z",
  fill: "#53C38E"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29.519 17.596v-.169c0-.043-.045-.086-.08-.125-.045 0-.09 0-.132.039l-.083.127c-4.2 4.823-7.676 10.19-10.438 15.938l-.089.124v.128c.036.038.036.038.09.038h.035l.125-.038a75.668 75.668 0 017.129-2.518.647.647 0 00.336-.25c1.052-2.013 3.478-5.956 3.478-5.956.09-.127.05-.253.05-.253s-.421-4.697-.421-7.085",
  fill: "#53C38E"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M34.888 10.8c-.583-.505-1.476-.756-2.813-.796-1.168-.043-2.601.251-4.236.754-.25.086-.42.21-.63.376-1.674 1.553-3.265 3.232-4.778 4.91l-.13.124c-.04.043-.04.083 0 .127.04.042.085.082.13.042l.167-.043a66.42 66.42 0 017.381-1.177c.167 0 .336.044.458.127.134.127.17.254.17.42a71.455 71.455 0 00.25 7.214v.168c0 .04.05.084.085.084h.045c.045 0 .08 0 .08-.043l.087-.126a63.893 63.893 0 014.444-5.659 1.19 1.19 0 00.255-.506c.497-3.062-.255-5.408-.965-5.995z",
  fill: "#53C38E"
});

var SvgSourceRobinhood = function SvgSourceRobinhood(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSourceRobinhood, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/source_robinhood.51fb9848.svg";
export { ForwardRef as ReactComponent };